goog.provide('el8.uiwidget.LegacyMindreader');

goog.require('el8.service.Search');
goog.require('el8.template.uiwidget.LegacyMindreader');
goog.require('el8.util.string');


/**
 * You probably want to be looking at NewMindreader.js.
 *
 * This file is deprecated. Its primary remaining uses are in really old dialogs (orders, meds).
 */
el8.uiwidget.LegacyMindreader = function(opts) {

    var HIGH_Z_INDEX = 10000; // so dropdown is always on top
    var isInit = false;

    var INVALID_KEYS = {
        9: true,   // tab
        13: true,  // enter
        16: true,  // shift
        17: true,  // ctrl
        18: true,  // alt
        20: true,  // caps lock
        27: true,  // escape
        33: true,  // page up
        34: true,  // page down
        35: true,  // end
        36: true,  // home
        37: true,  // left arrow
        38: true,  // up arrow
        39: true,  // right arrow
        40: true,  // down arrow
        45: true   // insert
    };

    opts = opts || {};

    // Required options or data
    if (!opts.url && !opts.data) {
        return false;
    }

    opts.urlParams = opts.urlParams || {};

    opts.queryDelay = opts.queryDelay || 0.15;
    opts.minQueryLength = (opts.minQueryLength === undefined) ? 2 : opts.minQueryLength;
    opts.limit = opts.limit || 100;
    opts.selectFn = opts.selectFn || function() {};  // Called after server result is selected
    opts.selectInputFn = opts.selectInputFn || function() {};  // Called after user's own input text is selected

    opts.customRenderFn = opts.customRenderFn || function() {};
    opts.customContainerFn = opts.customContainerFn || null;

    // Usually want to set only one of these two
    opts.endActivityFn = opts.endActivityFn || function() {};      // Called after dropdownContainer is hidden, if hasActivity true

    opts.entryHeight = opts.entryHeight || 40;
    opts.containerWidth = opts.containerWidth || 450;
    opts.containerHeight = opts.containerHeight || 250;
    opts.containerLeftOffset = opts.containerLeftOffset || null;
    opts.containerTopOffset = opts.containerTopOffset || null;
    opts.stopKeyBubbleMap = opts.stopKeyBubbleMap || {};

    // opts.actions is an array of dicts with two keys
    // { 'name': 'View all...', 'actionFn': function() { do this...; } }
    opts.actions = opts.actions || [];

    // opts.sections is an array of dicts with two keys
    // { 'name': <short string>, 'title': <string describing section> }
    opts.sections = opts.sections || [];

    opts.noCache = (opts.noCache === true); // defaults to false
    opts.showOnFocus = (opts.showOnFocus === true); // defaults to false
    opts.showNoMatches = (opts.showNoMatches === true); // defaults to false
    opts.hasCountInfo = (opts.hasCountInfo === true); // defaults to false

    opts.appendTo = opts.appendTo || null;

    return {

         // the second param says: just do prefix matching, no edit-distance/similarity matching
         // which makes local search more similar to our Solr searches
        searchService : opts.data ? new el8.service.Search(opts.data, true, opts.rowToStringFn) : false,
        updateSearchData : function(data) {
            opts.data = data;
            if (this.searchService) {
                this.searchService.setRows(data);
            }
        },

        init: function(_input) {

            if (!_input) { return false; }

            this.popoverId = (_input.attr('name') || 'unknown') + '-popover-' + Date.now().toString();
            this.isShown = false;
            this.isEnabled = true;   // Initialize in enabled state
            this.isFrozen = false;
            this.isBusy = false; // Whether in the midde of requesting results
            this.hasActivity = false;
            this.isEngaged = false;  // Whether user has engaged in dropdown

            this.isClickBinded = false;
            this.ignoreRequest = false;

            this.resultsMap = {}; // Holds map of result arrays returned by server
            this.selectedItem = null;
            this.madeSelection = false;

            this.activeIndex = -1;          // Index of active result within container
            this.activeItem = null;
            this.$activeResult = null;      // Pointer to current active result

            this.delayTimeout = null;
            this.inFocus = null;

            this.activeRequest = null;

            if (!isInit) { this.cache = {}; }

            // --------------------
            // If already init, make sure to remove and unbind old inputField
            // --------------------
            if (isInit) {
                this.$inputField.removeClass("mr-input-field");
                this.unbindInputHandlers(this.$inputField);
            }
            this.$inputField = _input;
            this.$inputField.addClass("mr-input-field");
            this.bindInputHandlers(this.$inputField);

            this.$inputField.attr('aria-haspopup', true);
            this.$inputField.attr('aria-controls', this.popoverId);

            // Get info text ignore string
            this.ignoreStr = _input.attr('_infotext') || "";

            // --------------------
            // Build results display on first initialization
            // --------------------
            if (!isInit) {
                var hasActions = Boolean(opts.actions.length);
                if (!opts.customContainerFn) {
                    this.$dropdownContainer = $(el8.template.uiwidget.LegacyMindreader.container({
                        sections: opts.sections,
                        hasCountInfo: opts.hasCountInfo,
                        hasActions: hasActions
                    }));
                } else {
                    this.$dropdownContainer = $(opts.customContainerFn());
                }
                this.$dropdownContainer
                    .attr('id', this.popoverId)
                    .hide()
                    .css({ top: this.$inputField.outerHeight() + "px" })
                    .appendTo(opts.appendTo || document.body);
                this.$dropdownContent = $('.mr-dropdown-content', this.$dropdownContainer);
                this.sections = {};
                this.sectionTitles = {};
                if (opts.sections.length) {
                    for (var i=0; i<opts.sections.length; i++) {
                        this.sections[opts.sections[i]['name']] =
                            $('.mr-'+opts.sections[i]['name'], this.$dropdownContainer);
                        this.sectionTitles[opts.sections[i]['name']] =
                            $('.mr-title-'+opts.sections[i]['name'], this.$dropdownContainer);
                    }
                } else {
                    this.sections['matches'] = $('.mr-matches', this.$dropdownContainer);
                }

                // --------------------
                // Add action items
                // --------------------
                if (hasActions) {
                    this.$actionsSection = $('.mr-actions', this.$dropdownContainer);
                    for (var i=0; i<opts.actions.length; i++) {
                        var a = this.createDropdownItem("action", i, ['mr-action-item']);
                        a.text(opts.actions[i]['name']);
                        this.$actionsSection.append(a);
                    }
                }
            }

            isInit = true;
            return this;
        },

        // *****************************
        // Methods to fetch data
        // *****************************
        delay: function(callback, str, l) {
            if (this.delayTimeout) { this.clearDelay(); }
            this.delayStr = str;
            this.delayTimeout = setTimeout(function() {
                callback();
            }, l * 1000);
        },

        clearDelay: function() {
            if (this.delayTimeout) { clearTimeout(this.delayTimeout); }
            this.delayTimeout = undefined;
        },

        clearRequest: function() {
            this.clearDelay(); // clear the delay, if any
            this.ignoreRequest = true; // remains true until new results requested
        },

        requestResults: function(str) {
            if (!this.isEnabled || this.isFrozen || this.isBusy) { return; }
            // If have local searchService, show all values upon down arrow on empty str (up to limit)
            if (str.length === 0 && this.searchService) {
                var maxMatches = this.searchService.getRows().slice(0, opts.limit);
                this.renderResults(maxMatches);
                return;
            }
            if (!this.isValidInput(str)) { this.hide(); return; }
            if (str.length < opts.minQueryLength) { return; }
            this.ignoreRequest = false;
            this.madeSelection = false;
            // Do local search if specified
            if(this.searchService) {
                this.requestLocalResults(str);
                return;
            // Otherwise, lookup in cache or search on server
            } else {
                var that = this;
                var lookup = !opts.noCache ? this.lookupInCache(str) : null;
                if (lookup) {
                    this.renderResults(lookup);
                    this.clearDelay();
                } else {
                    var queryFn = function(_str) {
                        return function() {
                            that.isBusy = true;
                            var dataDict = opts.urlParams;
                            dataDict['q'] = _str;
                            dataDict['limit'] = opts.limit;
                            var url = jQuery.isFunction(opts.url) ? opts.url() : opts.url;
                            that.activeRequest = $.el8_ajax({
                                url: url,
                                data: dataDict,
                                type: 'get',
                                //dataType: 'json',
                                success: function(data) {
                                    if (!opts.noCache) { that.addToCache(_str, data); }
                                    if (!that.ignoreRequest) {
                                        that.renderResults(data);
                                    }
                                    that.isBusy = false;
                                }
                            });
                        };
                    };
                    this.delay(queryFn(str), str, opts.queryDelay);
                }
            }
        },

        requestLocalResults: function(str){
            var that = this;
            this.searchService.requestMatchingRows(str, opts.limit, function(token, matches){
                that.renderResults(matches);
            });
        },

        renderResults: function(_results) {

            if (!this.isEnabled || this.isFrozen) { return; }

            this.reset();
            this.show(true);
            this.resetResultsDisplay();

            if (_results['custom']) {
                $('.mr-subheader', this.$dropdownContainer).show();
                this.customRenderResults(_results['results']);
                this.resetScroll();
                // If no user input section, hide mindreader
                // if no results showing
                if (!this.hasResults()) {
                    this.renderNoResults();
                }
                return;
            }

            // If we just get a single array, treat it as "matches"
            if (_results instanceof Array) {
                this.resultsMap['matches'] = _results;
            } else {
                for (var name in this.sections) {
                    if (this.sections.hasOwnProperty(name)) {
                        this.resultsMap[name] = _results[name];
                    }
                }
            }

            for (var name in this.sections) {
                if (this.sections.hasOwnProperty(name)) {
                    if (this.resultsMap[name] && this.resultsMap[name].length) {
                        if (this.sectionTitles[name]) { this.sectionTitles[name].show(); }
                        for (var j=0; j<this.resultsMap[name].length; j++) {
                            var a = this.createDropdownItem(name, j, ['mr-result-item']);
                            a.html(this.formatResult(this.resultsMap[name][j]));
                            this.sections[name].append(a);
                        }
                    } else {
                        if (this.sectionTitles[name]) { this.sectionTitles[name].hide(); }
                    }
                }
            }

            if (opts.hasCountInfo) {

                var totalCount = _results['total_count'];
                var numMatches = this.resultsMap['matches'] ?
                    this.resultsMap['matches'].length : 0;

                // Append count display
                if (totalCount && totalCount > numMatches) {
                    $('.mr-results-info', this.$dropdownContainer).text(
                        'Displaying ' + numMatches + ' results of ' + totalCount + '.  Enter more information to narrow search.'
                    ).show();
                } else {
                    $('.mr-results-info', this.$dropdownContainer).hide();
                }
            }

            // Finally, make user input result active and we reset scroll
            this.resetScroll();

            // If no user input section, hide mindreader
            // if no results showing
            if (!this.hasResults()) {
                this.renderNoResults();
            }

        },

        renderNoResults: function() {
            if (opts.showNoMatches) {
                this.$dropdownContent.prepend(el8.template.uiwidget.LegacyMindreader.noMatchesFyi({}));
            } else {
                this.hide();
            }
        },

        customRenderResults: function(results) {
            opts.customRenderFn(this, results);
        },

        resetResultsDisplay: function() {
            $('.mr-fyi', this.$dropdownContent).remove();
            $('.mr-extra-section', this.$dropdownContent).empty();
            for (var name in this.sections) {
                if (this.sections.hasOwnProperty(name)) {
                    this.sections[name].empty();
                }
            }
        },

        // ***************************
        // Public methods for fetching selected item
        // ***************************
        getSelectedItem: function() {
            var selectedVal = this.selectedItem ? this.formatSelected(this.selectedItem) : '';
            return el8.util.string.escapedStrEqual(selectedVal, this.getInputVal()) ? this.selectedItem : '';
        },
        setSelectedItem: function(e, item, noTrigger) {
            this.selectedItem = item;
            var val = this.formatSelected(item);
            if (noTrigger) {
                this.$inputField.val(val.el8_unescape());
            } else {
                this.$inputField.val(val.el8_unescape()).blur().change();
            }
            opts.selectFn(e || {}, this.selectedItem, this);
        },

        // ***************************
        // Keyboard and mouse handling methods
        // ***************************
        bindInputHandlers: function(_input) {
            var that = this;
            this.keydownHandler = function(e) {
                // First case is when dropdown is displayed
                if (that.isDropdownDisplayed()) {
                    switch (e.keyCode) {
                        case KEYS.TAB:
                            that.hide();
                            break;

                        case KEYS.ESC:
                            e.preventDefault();
                            that.hide();
                            if (!opts.showOnFocus) { return false; }
                            break;

                        case KEYS.UP:
                            if (!that.isBusy && opts.listeditor && !that.hasResults()) {
                                return;
                            }
                            e.preventDefault();
                            that.clearRequest(); // ignore requests already made
                            that.freeze();       // don't make any new requests until new key
                            if (that.$activeResult) {
                                var top = that.$activeResult.position().top;
                                if (top < opts.entryHeight) {
                                    var scrollTop = that.$dropdownContent.scrollTop();
                                    that.$dropdownContent.scrollTop(scrollTop+top-opts.entryHeight);
                                }
                                // See the mousemove handler for details about this hacky flag and why it exists
                                that._keydownScroll = true;
                            } else {
                                that.resetScroll();
                            }
                            that.activatePrev();
                            if (that.isEngaged && opts.stopKeyBubbleMap[e.keyCode]) { return false; }
                            break;

                        case KEYS.DOWN:
                            if (!that.isBusy && opts.listeditor && !that.hasResults()) {
                                return;
                            }
                            e.preventDefault();
                            that.clearRequest(); // ignore requests already made
                            that.freeze();       // don't make any new requests until new key
                            that.isEngaged = true;
                            if (that.$activeResult) {
                                var containerHeight = that.$dropdownContainer.height();
                                var bottom = (that.$activeResult.offset().top -
                                        that.$dropdownContainer.offset().top) +
                                        that.$activeResult.height();
                                if (bottom - containerHeight > -1*opts.entryHeight) {
                                    var scrollTop = that.$dropdownContent.scrollTop();
                                    that.$dropdownContent.scrollTop(scrollTop+bottom-containerHeight+opts.entryHeight);
                                }
                                that._keydownScroll = true;
                            } else {
                                that.resetScroll();
                            }
                            that.activateNext();
                            if (opts.stopKeyBubbleMap[e.keyCode]) { return false; }
                            break;

                        case KEYS.ENTER:
                            e.preventDefault();
                            if (opts.listeditor) { break; }
                            var noBubble = that.selectActiveResult(e);
                            that.clearRequest();
                            if (noBubble || opts.stopKeyBubbleMap[e.keyCode]) { return false; }
                            break;

                        case KEYS.BACKSP:
                            // Cancel any outstanding requests
                            that.clearRequest();
                            break;

                        //case KEYS.PAGEUP:
                        //case KEYS.PAGEDOWN:
                        default:
                            that.unfreeze();
                            break;
                    }
                // Else if dropdown is not displayed
                } else {
                    switch (e.keyCode) {
                        case KEYS.DOWN:
                            if (!opts.listeditor) {
                                that.requestResults(that.getInputVal());
                                return false;
                            }
                            break;

                        case KEYS.ESC: // mimic blur
                        case KEYS.TAB: // mimic blur
                        case KEYS.BACKSP:
                            // Cancel any outstanding requests
                            that.clearRequest();
                            break;

                        case KEYS.ENTER:
                            // Execute the default behavior when selecting
                            // own input text
                            opts.selectInputFn(e);
                            that.clearRequest();
                            break;

                        default:
                            break;
                    }
                }
            };
            this.keyupHandler = function(e) {
                // Need to do search on keyUp, after character is registered
                if (that.isEnabled) {
                    if (!(e.keyCode in INVALID_KEYS)) {
                        that.hasActivity = true;
                        if (!(e.keyCode === KEYS.BACKSP && !that.getInputVal())) {
                            that.requestResults(that.getInputVal());
                        } else {
                            that.hide();
                        }
                    }
                }
            };
            this.focusHandler = function(e) {
                if (opts.showOnFocus) {
                    // if showOnFocus, automatically show dropdown on focus
                    that.requestResults(that.getInputVal());
                } else if (!that.madeSelection && !that.hasInput()) {
                    that.show();
                }
                that.unfreeze();
            };

            if (!this.isInputBinded) {
                _input.attr("autocomplete", "off")
                    .keyup(this.keyupHandler)
                    .keydown(this.keydownHandler)
                    .focus(this.focusHandler);
                this.isInputBinded = true;
            }

        },
        unbindInputHandlers: function(_input) {
            if (this.isInputBinded) {
                _input.unbind('keyup', this.keyupHandler)
                    .unbind('keydown', this.keydownHandler)
                    .unbind('focus', this.focusHandler);
                this.isInputBinded = false;
            }
        },
        bindClickHandler: function() {
            var that = this;
            this.clickHandler = function(e) {
                if (opts.listeditor) { return; }
                var $resultRow = $(e.target).closest('.mr-dropdown-item');
                if ($resultRow.length) {
                    e.preventDefault();
                    that.setActiveResult(that._getIndex($resultRow));
                    that.selectActiveResult(e);
                    return false;
                } else if ($(e.target).hasClass("mr-input-field") && (e.target === that.$inputField.get(0))) {
                    return;
                } else {
                    that.hide(); // mimic blur
                    return false;
                }
            };
            if (!this.isClickBinded) {
                $(document).on('click', this.clickHandler);
                this.isClickBinded = true;
            }
        },

        unbindClickHandler: function() {
            if (this.clickHandler && this.isClickBinded) {
                $(document).unbind('click', this.clickHandler);
                this.isClickBinded = false;
            }
        },

        // ***************************
        // Navigation and rendering methods
        // ***************************
        isDropdownDisplayed: function() {
            return this.$dropdownContainer && !this.$dropdownContainer.is(":hidden");
        },

        resetScroll: function() {
            this.$dropdownContent.scrollTop(0);
        },

        numResults: function() { return $(".mr-result-item", this.$dropdownContainer).length; },

        numItems: function() { return $(".mr-dropdown-item", this.$dropdownContainer).length; },

        getNthItem: function(n) {  // 0-indexed
            if (this.isDropdownDisplayed()) {
                var mod_n = n % this.numItems();   // modulo length of results array + one for user input
                return $(".mr-dropdown-item", this.$dropdownContainer).eq(mod_n);
            }
            return null;
        },

        activateNext: function() {
            var index = this.activeIndex + 1;
            if (index >= this.numItems())  {
                index = this.activeIndex;  // Don't move below bottom
            } else {
                this.setActiveResult(index);
            }
        },

        activatePrev: function() {
            var index = this.activeIndex - 1;
            if (index < 0) {
                index = this.activeIndex; // Don't move above top; don't do anything
            } else {
                this.setActiveResult(index);
            }
        },

        hasResults: function() {
            return (this.numResults() >= 1);
        },

        setActiveResult: function(index, noIndexSet, automatedSelection) {

            automatedSelection = automatedSelection || false; //true to avoid freezing the MR

            if (this.$activeResult) { this.$activeResult.removeClass("mr-selected"); }
            this.$activeResult = null;
            this.activeIndex = -1;
            this.unfreeze();

            if ((index !== null) && (index >= 0) && this.isDropdownDisplayed()) {
                this.$activeResult = this.getNthItem(index);
                if (this.$activeResult) {
                    this.$activeResult.addClass("mr-selected");
                    this.activeItem = this._fetchItem(
                        this.$activeResult.attr("_mr_list"),
                        this.$activeResult.attr("_mr_index")*1
                    );
                }
                // If index is 0, then can set index anyway so
                // down arrow doesn't have to be hit twice to select
                if (!noIndexSet || index === 0) {
                    this.activeIndex = index;
                }

                 if (!automatedSelection) {
                    //TODO: unknown why this freezing is here, but we're limiting
                    // the scope of the change for rb_app_20120918
                    //NOTE: copied from NewMindreader
                    this.freeze();

                    var that = this;
                    var do_unfreeze = function() { that.unfreeze(); };
                    setTimeout(do_unfreeze, 10);
                }
            }
        },

        selectActiveResult: function(e) {
            var noBubble = false;
            if (this.$activeResult) {
                // Should apply to any of the "mr-result-item' entries
                if (this.activeItem) {
                    this.setSelectedItem(e, this.activeItem);
                    this.$inputField.focusFocus(); // expect to happen above hiding mindreader

                // Else, the "mr-action-item" entries
                } else if (this.$activeResult.hasClass("mr-action-item")) {
                    var actionIndex = this.$activeResult.attr("_mr_index")*1;
                    opts.actions[actionIndex]['actionFn'](this.$inputField.val());
                    this.setInputVal('');
                    noBubble = true;

                // Finally, the "mr-input-item" entry
                }  else {
                    opts.selectInputFn(e);
                    noBubble = false;
                }
                this.hide();
            }
            this.madeSelection = true;
            return noBubble;
        },

        createDropdownItem: function(list, index, classes) {
            var that = this;
            var $item = $(el8.template.uiwidget.LegacyMindreader.item({
                listName: list,
                index: index,
                classes: classes
            }));
            $item.mousemove(_.debounce(function(e) {
                /* This terrible keydownScroll flag is used to hack around a bug with the mousemove event.
                 * When we scroll from keydown/keyup, the position of mindreader items changes and they
                 * "scroll", which triggers this event. So if the mouse happens to be over a mindreader,
                 * after paging down, the mouse will jump back to the cursor location. We use this flag
                 * to ignore the first mousemove after a keydown. */
                if (that._keydownScroll) {
                    that._keydownScroll = false;
                    return;
                }
                that.isEngaged = true;
                that.setActiveResult(that._getIndex(this));
            }, el8.util.consts.MOUSEMOVE_RATE, true));
            return $item;
        },

        // ***************************
        // Cache management
        // ***************************
        clearCache: function() { this.cache = {}; },
        addToCache: function(q, results) {
            if (q) { this.cache[q] = results; }
        },
        lookupInCache: function(q) {
            if (this.cache.hasOwnProperty(q)) {
                return this.cache[q];
            }
            return false;
        },

        // ***************************
        // User input
        // ***************************
        hasInput: function() {
            return this.isValidInput(this.$inputField.val());
        },
        isValidInput: function(str) {
            return (str.toLowerCase() !== this.ignoreStr.toLowerCase());
        },
        getInputVal: function() {
            var val = this.$inputField.val();
            if (val.toLowerCase() === this.ignoreStr.toLowerCase()) {
                return '';
            }
            return val;
        },
        setInputVal: function(val, doFocus) {
            this.$inputField.val(val);
            if (doFocus) { this.$inputField.focusFocus(); }
        },

        // ***************************
        // Formatting methods
        // ***************************
        formatResult: opts.formatResult || function(obj) { return obj; },  // XSS OK -KF (rely on caller)
        formatSelected: opts.formatSelected || function(obj) { return obj; },

        // ***************************
        // Core methods
        // ***************************
        reset: function() {
            this.resultsMap = {};
            this.setActiveResult(null);
        },

        position: function() {
            var inputHeight = this.$inputField.outerHeight();
            this.$dropdownContainer.css({
                'left': this.$inputField.offset()['left'] + (opts.containerLeftOffset || 0),
                'top': this.$inputField.offset()['top'] + (opts.containerTopOffset || 0) + inputHeight,
                'z-index': HIGH_Z_INDEX,
                'width': opts.containerWidth
            });
            this.$dropdownContent.css({
                'max-height': opts.containerHeight
            });
        },

        show: function(force) {
            if ((this.hasInput() || force) && !this.isShown) {
                this.isShown = true;
                this.position();
                this.$dropdownContainer.show();
                this.bindClickHandler();
            }
        },

        hide: function() {
            this.clearRequest();
            if (this.isShown) {
                this.isShown = false;
                if (this.hasActivity) {
                    this.hasActivity = false;
                    opts.endActivityFn();
                }
                this.isEngaged = false; // reset
                this.reset();
                this.unbindClickHandler();
                this.resetResultsDisplay();
                this.$dropdownContainer.hide();
            }
        },

        enable: function() {
            this.isEnabled = true;
        },

        disable: function() {
            this.hide();
            this.isEnabled = false;
        },

        freeze: function() { this.isFrozen = true;},
        unfreeze: function() { this.isFrozen = false;},

        checkIsEngaged : function() { return this.isEngaged;},

        // ************************
        // Utility methods
        // ************************
        _fetchItem: function(list, index) {
            if (this.resultsMap[list] && !isNaN(index)) {
                return this.resultsMap[list][index];
            }
            return null;
        },
        _getIndex: function($div) {
            return $('.mr-dropdown-item', this.$dropdownContainer).index($div);
        }

    };

};
